<template>
  <div class="tab">
    <div v-if="!this.isLoading">
      <div class="dashboard-menu">
        <div
          class="dashboard-menu-item"
          @click="currentMenu = 1"
          :class="[currentMenu === 1 ? 'active' : '']"
        >
          Panel główny
        </div>
        <div
          class="dashboard-menu-item"
          @click="currentMenu = 2"
          :class="[currentMenu === 2 ? 'active' : '']"
        >
          Porównanie z ubiegłym tygodniem
        </div>
        <div
          class="dashboard-menu-item"
          @click="currentMenu = 3"
          :class="[currentMenu === 3 ? 'active' : '']"
        >
          Usunięte zmiany
        </div>
      </div>
      <div v-if="currentMenu === 1">
        <b-row class="main-settings" align-v="stretch">
          <b-col>
            <info-bar
              title="Wybrany tydzień"
              :content="`${returnWeekText}`"
              icon="calendar"
              variant="secondary"
            ></info-bar>
          </b-col>
          <b-col
            ><info-bar
              title="Ilość dostępnych zmian"
              variant="secondary"
              icon="puzzle"
              :content="leftShifts"
            ></info-bar
          ></b-col>
        </b-row>
        <b-row class="align-items-center info-section">
          <b-col
            ><info-bar
              title="Wypełnienie grafiku"
              variant="warning"
              icon="square-half"
              :content="`${
                getAverageShifts.perc > 0
                  ? getAverageShifts.perc + '%'
                  : 'Wygeneruj grafik'
              }`"
          /></b-col>
          <b-col
            ><info-bar
              title="Wypełnienie zmian"
              variant="secondary"
              icon="layers-half"
              :content="`${returnCapacity.takenShifts}/${returnCapacity.availableShifts} `"
          /></b-col>
          <b-col
            ><info-bar
              title="Wynajem (zmiany)"
              variant="secondary"
              icon="layers-half"
              :content="`${returnCapacity.rentalShifts}`"
          /></b-col>
          <b-col
            ><info-bar
              title="Przesłane grafiki"
              variant="secondary"
              icon="people"
              :content="
                returnDetails.amount > 0
                  ? returnDetails.amount
                  : 'Brak przesłanych grafików'
              "
          /></b-col>
        </b-row>
        <b-row class="align-items-center info-section">
          <b-col
            ><info-bar
              title="Potrzebne osoby do grafiku"
              variant="warning"
              icon="exclamation-circle"
              :content="getAverageShifts.avgLeft"
          /></b-col>
          <b-col
            ><info-bar
              title="Średnia zmian / osoba"
              variant="secondary"
              icon="bar-chart-fill"
              :content="`${getAverageShifts.avgPerPerson} `"
          /></b-col>
          <b-col
            ><info-bar
              title="Aktywni kierowcy"
              icon="pencil"
              :content="`${returnDrivers.length}`"
          /></b-col>
        </b-row>
        <b-row class="shift-checker" v-if="getTopDays">
          <b-col>
            <info-bar
              title="Ostatnio przesłane"
              :content="returnDetails.schedules.slice(-3)"
              icon="calendar"
              variant="secondary"
              mode="lastPersons"
            ></info-bar>
          </b-col>
        </b-row>
        <b-row class="shift-checker" v-if="getTopDays">
          <b-col>
            <info-bar
              title="Braki dyspozycji"
              :content="returnMissing"
              icon="calendar"
              variant="secondary"
              mode="missing"
            ></info-bar>
          </b-col>
        </b-row>
      </div>
      <div class="tab" v-if="currentMenu === 2">
        <b-row class="main-settings" align-v="stretch">
          <h2>Przejazdy / zmiany</h2>
          <b-table
            :items="returnDataForTable"
            :fields="fields"
            class="weekly-box"
          >
          </b-table>
          <h2>Widok dzienny</h2>
          <b-table
            :items="returnDataForSecondTable"
            :fields="secondFields"
            class="weekly-box"
          ></b-table>
        </b-row>
      </div>
      <div class="tab" v-if="currentMenu === 3">
        <b-row class="main-settings" align-v="stretch">
          <h2>Usunięte zmiany</h2>
          <b-button @click="downloadCsv" variant="primary"
            >Pobierz do CSV <b-icon icon="download"></b-icon
          ></b-button>
          <b-table
            :items="returnRemovedShifts"
            :fields="removedShiftsFields"
            class="weekly-box"
          >
          </b-table>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import infoBar from "../components/bars/InfoBar.vue";
export default {
  name: "Dashboard-panel",
  components: {
    infoBar,
  },
  data() {
    return {
      isLoading: false,
      currentMenu: 1,
      isResultsLoading: false,
      removedShiftsFields: [
        { key: "day", label: "Dzień" },
        { key: "driver", label: "Kierowca" },
        { key: "shift", label: "Zmiana" },
        { key: "reason", label: "Powód" },
        { key: "createdAt", label: "Data usunięcia", sortable: true },
        { key: "user", label: "Usunięte przez" },
      ],
      fields: [
        { key: "week", label: "Tydzień" },
        { key: "total", label: "Ilość zmian", sortable: true },
        { key: "totalDay", label: "Ilość dniówek", sortable: true },
        { key: "totalNight", label: "Ilość nocek", sortable: true },
        {
          key: "totalDayRides",
          label: "Ilość przejazdów dzień",
          sortable: true,
        },
        {
          key: "totalNightRides",
          label: "Ilość przejazdów noc",
          sortable: true,
        },
      ],
      secondFields: [
        { key: "day", label: "Dzień" },
        { key: "currentWeekDay", label: "Obecny - dniówki", sortable: true },
        {
          key: "previousWeekDay",
          label: "Poprzedni - dniówki",
          sortable: true,
        },
        { key: "currentWeekNight", label: "Obecny - noce", sortable: true },
        { key: "previousWeekNight", label: "Poprzedni - noce", sortable: true },
        { key: "currentDayRides", label: "Obecny - przejazdy dzień" },
        {
          key: "previousDayRides",
          label: "Poprzedni - przejazdy dzień",
          sortable: true,
        },
        {
          key: "currentNightRides",
          label: "Obecny - przejazdy noc",
          sortable: true,
        },
        {
          key: "previousNightRides",
          label: "Poprzedni - przejazdy noc",
          sortable: true,
        },
        { key: "currentWeekNight", label: "Obecny - noce", sortable: true },
        { key: "previousWeekNight", label: "Poprzedni - noce", sortable: true },
        {
          key: "currentDayRides",
          label: "Obecny - przejazdy dzień",
          sortable: true,
        },
        {
          key: "previousDayRides",
          label: "Poprzedni - przejazdy dzień",
          sortable: true,
        },
        {
          key: "currentNightRides",
          label: "Obecny - przejazdy noc",
          sortable: true,
        },
        {
          key: "previousNightRides",
          label: "Poprzedni - przejazdy noc",
          sortable: true,
        },
      ],
    };
  },
  created() {
    this.fetchSettings();
  },
  methods: {
    async fetchSettings() {
      await this.getSettings();
      let correctYear = this.returnSettings.adminWeek < 52 ? 2026 : 2025;

      await this.$store
        .dispatch("fetchDetails", {
          week: this.returnSettings.adminWeek,
          year: correctYear,
        })
        .catch((error) => console.log(error));
      await this.$store.dispatch("getDrivers");
      await this.$store.dispatch("fetchGeneratedWeek", {
        week: this.$store.state.settings.adminWeek,
        year: correctYear,
      });
      await this.$store.dispatch("fetchPrevGeneratedWeek", {
        week: this.$store.state.settings.adminWeek - 1,
        year: correctYear,
      });
      await this.$store.dispatch("getRemovedShifts");
      const start = this.$dayjs()
        .week(this.$store.state.settings.adminWeek - 1)
        .startOf("week")
        .format("YYYY-MM-DD");
      const end = this.$dayjs()
        .week(this.$store.state.settings.adminWeek)
        .endOf("week")
        .format("YYYY-MM-DD");
      await this.$store.dispatch("getBoltResults", {
        startDate: start,
        endDate: end,
      });

      this.isLoading = false;
    },
    async downloadCsv() {
      const csvData = this.$store.getters["getRemovedShifts"];
      if (!csvData.length) return;

      // Define headers in Polish
      const headers = [
        "Dzień",
        "Kierowca",
        "Zmiana",
        "Powód",
        "Data usunięcia",
        "Usunięte przez",
      ];

      // Map data to match header order (adjust keys if needed)
      const rows = csvData.map((e) => [
        e.day,
        e.driver,
        e.shift,
        e.reason,
        e.createdAt,
        e.user,
      ]);

      // Compose CSV content with BOM and semicolon separator
      const csvContent =
        "\uFEFF" +
        [headers, ...rows]
          .map((row) =>
            row
              .map((val) => `"${(val ?? "").toString().replace(/"/g, '""')}"`)
              .join(";")
          )
          .join("\n");

      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.setAttribute(
        "download",
        `removed_shifts_${this.$dayjs().format("YYYY-MM-DD")}.csv`
      );
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    async getSettings() {
      this.isLoading = true;
      await this.$store.dispatch("fetchASettings");
    },
    async changeTabToResult() {
      this.isResultsLoading = true;
      await this.$store.dispatch("fetchDashboardDailyResult");
      this.currentMenu = 2;

      this.isResultsLoading = false;
    },
    async changeTabToLastWeek() {
      this.isResultsLoading = true;
      await this.$store.dispatch("fetchDashboardWeeklyResult");
      this.currentMenu = 3;

      this.isResultsLoading = false;
    },
  },
  computed: {
    getTopDays() {
      return !this.isLoading && this.$store.getters["returnMaxDays"];
    },
    compareWeeks() {
      return !this.isLoading && this.$store.getters["compareWeeks"];
    },
    boltResults() {
      return !this.isLoading && this.$store.getters["getBoltResults"];
    },

    returnRemovedShifts() {
      return !this.isLoading && this.$store.getters["getRemovedShifts"];
    },

    returnDataForTable() {
      return (
        !this.isLoading && [
          {
            total: this.compareWeeks.current.total,
            totalDay: this.compareWeeks.current.totalDay,
            totalNight: this.compareWeeks.current.totalNight,
            week: this.compareWeeks.current.week,
            totalDayRides: this.compareWeeks.current.totalDayRides,
            totalNightRides: this.compareWeeks.current.totalNightRides,
          },
          {
            total: this.compareWeeks.previus.total,
            totalDay: this.compareWeeks.previus.totalDay,
            totalNight: this.compareWeeks.previus.totalNight,
            week: this.compareWeeks.previus.week,
            totalDayRides: this.compareWeeks.previus.totalDayRides,
            totalNightRides: this.compareWeeks.previus.totalNightRides,
          },
        ]
      );
    },

    returnDataForSecondTable() {
      const compareWeeks = this.$store.getters["compareWeeks"];
      const toDisplay = [];
      for (let i = 0; i < 7; i++) {
        const weekNames = [
          "Poniedziałek",
          "Wtorek",
          "Środa",
          "Czwartek",
          "Piątek",
          "Sobota",
          "Niedziela",
        ];
        const dayOfWeek = weekNames[i];
        const currentWeekDay = compareWeeks.current.days[i].dayShifts;
        const previousWeekDay = compareWeeks.previus.days[i]?.dayShifts;
        const currentWeekNight = compareWeeks.current.days[i]?.nightShifts;
        const previousWeekNight = compareWeeks.previus.days[i]?.nightShifts;
        const currentDayRides = compareWeeks.current.days[i]?.totalDayRides;
        const previousDayRides = compareWeeks.previus.days[i].totalDayRides;
        const currentNightRides = compareWeeks.current.days[i].totalNightRides;
        const previousNightRides = compareWeeks.previus.days[i].totalNightRides;
        toDisplay.push({
          day: dayOfWeek,
          currentWeekDay,
          previousWeekDay,
          currentWeekNight,
          previousWeekNight,
          currentDayRides,
          previousDayRides,
          currentNightRides,
          previousNightRides,
        });
      }
      return !this.isLoading && toDisplay;
    },
    returnDrivers() {
      const driversList =
        !this.isLoading && this.$store.getters["getDriverList"];
      return driversList.filter((el) => el.active);
    },
    returnSettings() {
      return this.$store.getters["getSettings"];
    },
    returnDashboardShifts() {
      const response = this.$store.getters["getDashboardResult"];
      const dayShifts = response.filter(
        (item) => item && item.attributes?.shift === "day"
      );
      const nightShifts = response.filter(
        (item) => item && item.attributes?.shift === "night"
      );

      dayShifts.sort((a, b) => b.totalEarned - a.totalEarned);
      nightShifts.sort((a, b) => b.totalEarned - a.totalEarned);

      return !this.isResultsLoading && { dayShifts, nightShifts };
    },
    returnWeeklyDashboardShifts() {
      return (
        !this.isResultsLoading &&
        this.$store.getters["getDashboardWeeklyResult"]
      );
    },

    returnDetails() {
      return !this.isLoading && this.$store.getters["getDetails"];
    },
    returnMissing() {
      const schedules = this.returnDetails.schedules;
      const listOfSchedules = [];
      for (let i = 0; i < schedules.length; i++) {
        let id = schedules[i].id;
        listOfSchedules.push({ ...schedules[i].attributes, id });
      }
      const missingDrivers = [];
      for (let i = 0; i < this.returnDrivers.length; i++) {
        if(this.returnDrivers[i].onHold) continue;
        let find = listOfSchedules.find(
          (el) => this.returnDrivers[i].phoneNumber === el.phone 
        );
        if (!find) {
          missingDrivers.push(this.returnDrivers[i]);
        }
      }
      return missingDrivers;
    },
    returnWeekText() {
      const adminWeek = this.$store.state.settings.adminWeek;
      let year = this.$store.state.settings.adminYear;

      adminWeek < 52 ? (year = year + 1) : year;

      return `${this.$dayjs().week(adminWeek).year(year).weekday(0).$D}.${
        this.$dayjs().week(adminWeek).year(year).weekday(0).$M + 1
      }.${this.$dayjs().week(adminWeek).year(year).weekday(0).year()} - ${
        this.$dayjs().week(adminWeek).year(year).weekday(6).$D
      }.${
        this.$dayjs().week(adminWeek).year(year).weekday(6).$M + 1
      }.${this.$dayjs().week(adminWeek).year(year).weekday(6).year()}`;
    },
    getAverageShifts() {
      const shiftNum = this.returnDetails.shiftsAmount;
      const people = this.returnDetails.amount;
      const avgPeople = shiftNum / people;
      const avgLeft = this.leftShifts / avgPeople;
      const perc =
        (100 * this.returnCapacity.takenShifts) /
        this.returnCapacity.availableShifts;
      return (
        !this.isLoading && {
          avgPerPerson: avgPeople ? avgPeople.toFixed(1) : "",
          avgLeft: avgLeft ? avgLeft.toFixed(1) : "",
          perc: perc.toFixed(0),
        }
      );
    },
    generatedWeek() {
      const week = this.$store.state.generatedWeeks[0];
      return week ? { day: week.days, night: week.nights } : false;
    },
    returnCapacity() {
      const nights = this.generatedWeek.night;
      const days = this.generatedWeek.day;
      let availableShifts = 0;
      let takenShifts = 0;
      let rentalShifts = 0;
      if (days && nights) {
        for (let i = 0; i < days.length; i++) {
          const day = days[i].day;
          let dayCars = days[i].cars;
          let nightCars = nights[i].cars;
          for (let a = 0; a < dayCars.length; a++) {
            const reg = dayCars[a].reg;
            const drivers = dayCars[a].drivers;
            if (!dayCars[a].grounded && !dayCars[a].isRented) {
              availableShifts++;
            }
            if (drivers.length && !dayCars[a].isRented) {
              takenShifts += drivers.length;
            }
            if (dayCars[a].isRented && dayCars[a].drivers.length) {
              rentalShifts += dayCars[a].drivers.length;
            }
          }
          for (let a = 0; a < nightCars.length; a++) {
            const reg = nightCars[a].reg;
            const drivers = nightCars[a].drivers;

            if (!nightCars[a].grounded && !nightCars[a].isRented) {
              availableShifts++;
            }
            // check if not on night shift
            if (drivers.length && !nightCars[a].isRented) {
              takenShifts += drivers.length;
            }
            if (nightCars[a].isRented && nightCars[a].drivers.length) {
              rentalShifts += nightCars[a].drivers.length;
            }
          }
        }
      }

      return !this.isLoading && { availableShifts, takenShifts, rentalShifts };
    },
    getShiftNumber() {
      const limit = this.returnSettings.defaultLimit;
      const maxShifts = 7 * limit * 2;
      return !this.isLoading && maxShifts;
    },
    leftShifts() {
      return (
        !this.isLoading &&
        this.returnCapacity.availableShifts - this.returnCapacity.takenShifts
      );
    },
    returnCurrentUser() {
      return !this.isLoading && this.$store.state.user;
    },
  },
};
</script>

<style scoped>
.info-section,
.main-settings,
.shift-checker {
  gap: 15px;
}
.dashboard-menu {
  display: flex;
  gap: 16px;
  margin-bottom: 16px;
}
.dashboard-menu-item {
  background: #fff;
  padding: 16px;
  border-radius: 16px;
  cursor: pointer;
  border: 1px solid #f78812;
}
.dashboard-menu-item:hover {
  background-color: #f78812;
  color: #fff;
  transition: 0.2s;
}
.active {
  background-color: #f78812;
}

.tab {
  width: 100%;
}

.result-box {
  border-radius: 16px;
  margin: 16px 0;
  -webkit-box-shadow: 8px 8px 24px 0px rgba(211, 212, 221, 1);
  -moz-box-shadow: 8px 8px 24px 0px rgba(211, 212, 221, 1);
  box-shadow: 8px 8px 24px 0px rgba(211, 212, 221, 1);
  padding: 32px;
}

.total-earned {
  font-size: 1.4em;
  font-weight: 600;
  text-align: right;
}
.total-earned .currency {
  font-size: 16px;
}
.apps {
  margin: 16px 0;
}
.app-single {
  margin: 8px 0;
}

.uber {
  border-bottom: 1px solid black;
}
.bolt {
  border-bottom: 1px solid rgb(65, 233, 32);
}
.freenow {
  border-bottom: 1px solid rgb(153, 51, 51);
}
.app-title {
  font-weight: 300;
}
.cash {
  text-align: right;
}
.weekly-box {
  border-radius: 16px;
  margin: 16px 0;
  -webkit-box-shadow: 8px 8px 24px 0px rgba(211, 212, 221, 1);
  -moz-box-shadow: 8px 8px 24px 0px rgba(211, 212, 221, 1);
  box-shadow: 8px 8px 24px 0px rgba(211, 212, 221, 1);
  padding: 32px;
}
</style>
